// extracted by mini-css-extract-plugin
export default {"transformBadge":"CustomEdges_transformBadge__bnVM2"};